export default __webpack_public_path__ + "static/media/endRound2.511dac98.mp3";